module.exports = __webpack_public_path__ + "static/desktop-b8672a722ca3b4b7d7ed405022abde77.webp";